import { render, staticRenderFns } from "./itemTitleForTab.vue?vue&type=template&id=be0ea028&scoped=true&"
import script from "./itemTitleForTab.vue?vue&type=script&lang=js&"
export * from "./itemTitleForTab.vue?vue&type=script&lang=js&"
import style0 from "./itemTitleForTab.vue?vue&type=style&index=0&id=be0ea028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0ea028",
  null
  
)

export default component.exports